site.nav = {
	selector: '#mobilemenu',

	init: function () {
		site.nav.cloneMenu();
		site.nav.bind();
		//site.nav.prependSearchBox();
		//site.nav.appendLanguage();
		site.nav.prependHeader();
		site.nav.appendStoreMenu();
		site.nav.appendQuickNav();
	},

	cloneMenu: function () {
		var $target = $('#mainmenu'),
			selector = site.nav.selector.substr(1),
			$html = $('<div id="' + selector + '" role="navigation" class="hidden-md hidden-lg"></div>'),
			$menu = $target.find('.mmLevel1').clone().removeAttr('id');
		$menu.find('ul').removeAttr('id');
		$html.append($menu);

		const megamenus = $html.find('.megamenu');
		megamenus.each(function() {
			const level2 = $(this).find('.mmLevel2');
			$(this).closest('.level1').append(level2);
			$(this).remove();
		});
		$html.find('.storeCategoryMenu').remove();

		$html.insertAfter($target);
		$target.addClass('hidden-sm hidden-xs');
	},

	bind: function () {
		// Add expand link to mobile menu
		$('<button class="expand" aria-label="Opna/loka"></button>')
			.insertAfter('#mobilemenu .children > a, #mobilemenu .children > div');
		$('li[class*="selectedLevel"]', site.nav.selector).addClass('down');

		// Mobile menu toggle
		$('#mainmenuToggle').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.nav.mobileToggle(e, menuOpen);

			if (!menuOpen) {
				$(this).attr('aria-expanded', true);
			}
			else {
				$(this).removeAttr('aria-expanded');
			}

			$(site.nav.selector).on('click', function (e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open').on('click', function (e) {
				$('body').removeClass('mainmenu-open');
				site.nav.closeMenu();
			});
		});

		// Expand in mobile menu
		$('.expand', site.nav.selector).bind('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$('#mobilemenu').animate({
				scrollTop:0
			},500);
			$(this).closest('li').toggleClass('down');
		});
	},
	// Toggle mobile menu
	mobileToggle: function (e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
		if (menuOpen) {
			site.nav.closeMenu();
		} else {
			$('body').removeClass('storeShoppingBag-open');
		}
	},

	closeMenu: function() {
		var $body = $('body');
		$body.addClass('mainmenu-closing')
		setTimeout(function() {
			$('body').removeClass('mainmenu-closing');
		},300);

	},

	// Append language to site
	appendLanguage: function () {
		var $divisions = $('.menu', '#divisions');
		var $menu = $('ul.mmLevel1', site.nav.selector);

		$divisions.find('li').each(function () {
			var $li = $(this).clone();
			$li.addClass('ele-language level1');
			$menu.append($li);
		});
	},

	appendStoreMenu: function () {
		if (!$('body').is('.storeUser')) {
			return;
		}
		const $menu = $('ul.mmLevel1', site.nav.selector),
			menuUrl = '/_/moya/store/mypage/menu';

		$.ajax({
			url: menuUrl,
			success: function (data) {
				$menu.append('<div class="mobileStoreMenu">' + data + '</div>');
				$menu.find('#storeMypageMenu').removeAttr('id')
			}
		});
	},

	appendQuickNav: function () {
		var $qn = $('#qn');
		var $menu = $('ul.mmLevel1', site.nav.selector);
		var $qnContentLeft = '';
		var $qnContentRight = '';

		$qn.find('.left').each(function () {
			$qnContentLeft += '<div class="qn mobileQn">' + $(this).clone().html() + '</div>';
		});
		$qn.find('.right #storeCustomerMenu > ul li:last-of-type').each(function () {
			$qnContentRight += '<div class="mobileLogout">' + $(this).clone().html() + '</div>';
		});
		$menu.prepend($qnContentRight);
		$menu.append($qnContentLeft);
	},

	prependSearchBox: function () {
		var $mainmenu = $(site.nav.selector),
			$mSearchBox = $('#searchBox').clone().removeAttr('id').attr('id', 'mSearchBox');
		$mainmenu.prepend($mSearchBox);

		$('[id]', $mSearchBox).each(function () {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm' + $id.substr(0, 1).toUpperCase() + $id.substr(1),
				$label = $('label[for="' + $id + '"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);
		});
	},

	prependHeader: function() {
		$('.mmLevel1 ul', site.nav.selector).each(function() {
			var $title = $(this).closest('li').find('>a, > div').clone();
			$title.addClass('back');
			$(this).prepend($title);
		});
		$('.back', site.nav.selector).wrap('<li class="header">');
		$('div.back', site.nav.selector).wrapInner('<a href="#" class="back">');
		$('div.back a.back', site.nav.selector).unwrap();

		$('a.back', site.nav.selector).on('click', function(e) {
			e.preventDefault();
			$(this).closest('li.down').removeClass('down');
		});
	}
};
